import { MenuProps } from 'antd'
import { useTranslation } from 'react-i18next'
import { GlobalOutlined } from '@ant-design/icons'

import { Dropdown, Flex } from 'components/uiKit'
import { getNormalizedLanguage } from 'utils/helpers/i18n/getCurrentLanguage'
import { colors } from 'shared/constants/values'

import { TextPromo } from '../TextPromo/TextPromo'

import s from './LangSwitcher.module.scss'

type SupportedLanguages = 'ru' | 'ka' | 'az'

type LangSwitcherProps = {
  style?: React.CSSProperties
}

export const LangSwitcher = ({ style }: LangSwitcherProps) => {
  const { i18n } = useTranslation()

  const languageMapping: Record<SupportedLanguages, string> = {
    ru: 'RU',
    ka: 'GE',
    az: 'AZ',
  }

  const items: MenuProps['items'] = [
    {
      key: '1',
      label: 'Русский',
      onClick: () => {
        i18n.changeLanguage('ru').then(() => {
          sessionStorage.setItem('i18nextLng', 'ru')
          window.location.reload()
        })
      },
    },
    {
      key: '3',
      label: 'ქართული',
      onClick: () => {
        i18n.changeLanguage('ka').then(() => {
          sessionStorage.setItem('i18nextLng', 'ka')
          window.location.reload()
        })
      },
    },
  ]

  return (
    <Dropdown
      menu={{ items }}
      placement="bottomRight"
      dropdownRender={(menu) => <div style={{ marginTop: '24px' }}>{menu}</div>}
    >
      <Flex className={s.langSwitcher} gap={8} align="center" style={style}>
        <TextPromo fontFamily="ASLHauss" size="s20" style={{ color: 'black' }}>
          {languageMapping[getNormalizedLanguage()]}
        </TextPromo>
        <GlobalOutlined style={{ color: colors.black }} />
      </Flex>
    </Dropdown>
  )
}
